module.exports = __webpack_public_path__ + "img/move.4be42235.png";